import moment from 'moment';

export class DateHelper {
    static formatDate = (date, format) => {
        return moment(new Date(date)).format(format);
    }
}